module.exports = __webpack_public_path__ + "static/img/logo2.f4a3a98.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/logo2.png
// module id = 5RMf
// module chunks = 74